/* eslint-disable */
import {
    DollarOutlined,
    LoadingOutlined,
    ZoomOutOutlined
} from '@ant-design/icons'
import { Button, Card, Col, DatePicker, Form, Input, Row, Spin, Table, Tabs, Tag, Tooltip, message } from 'antd';
import type { ColumnsType, SorterResult } from 'antd/es/table/interface';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import InstitutionUserService from '../../services/InstitutionUserService';
import { parseMoneyAmount } from '../../utils/parseMoneyAmount';
import { RefundStatsRangeAlert } from './RefundStatsRangeAlert';
import styles from '../../asserts/css/BiddersRefundRequest.module.css';

const antIcon = <LoadingOutlined style={{ fontSize: 'var(--base-font-size)', color: '#37762F' }} spin />
const { RangePicker } = DatePicker

interface PaymentsMeta {
    total: number
    pageSize: number
    currentPage: number
}
interface DataType {
    index: any;
    key: React.Key
    bank_code: string
    transaction_reference: string
    debit_account_number: string
    debit_account_name: string
    beneficiary_account_name: string
    beneficiary_bank_name: string
    beneficiary_account_number: string
    transaction_currency: string
    amount: number
    reason: string
    status: string
    created_at: string;
    updated_at: string;
    created_by: string;
    column: string;
    totalPayments: number;
    amountRequestedToBeRefund: number;
    amountRequestedToBeRefundedInProgressStatus: number;
    TotalNumberOfApplicantRequestedRefund: number;
    notRequestedBidders: number;
}
const BiddersRefundRequest: React.FC = () => {
    const [form] = Form.useForm()
    const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}')
    const navigate = useNavigate()
    const [filterStatus, setfilterStatus] = useState('')
    const [clear, setClear] = useState(false)
    const [fromDate, setFromDate] = useState('')
    const [toDate, setToDate] = useState('')
    const [refundRequestList, setRefundRequestList] = useState<DataType[]>([]);
    const [paymentsMeta, setPaymentsMeta] = useState<PaymentsMeta | null>(null)
    const [loading, setLoading] = useState(false);
    const [sortedInfo, setSortedInfo] = useState<SorterResult<DataType>>({})
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10
    })
    const [bailiffRefundRequestList, setBailiffRefundRequestList] = useState<DataType[]>([]);
    const [stats, setStats] = React.useState<DataType | null>(null);
    const [totalAmount, setTotalAmount] = useState(0);
    const [activeTab, setActiveTab] = useState('bidders'); // Default tab
    const [appliedFilters, setAppliedFilters] = useState<string[]>([]);
    const [token, setToken] = useState('')
    const [BiddersAmountRequestedToBeRefund, setBiddersAmountRequestedToBeRefund] = useState('')
    const [BailiffAmountRequestedToBeRefunded, setBailiffAmountRequestedToBeRefunded] = useState('')
    const [NewBiddersAmountRequestedToBeRefunded, setNewBiddersAmountRequestedToBeRefunded] = useState('')
    const [NewBailiffAmountRequestedToBeRefunded, setNewBailiffAmountRequestedToBeRefunded] = useState('')
    const [totalPaidForRange, setTotalPaidForRange] = useState('')

    useEffect(() => {
          // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
          async function fetchRefundStats () {
              setLoading(true)
              try {
                  const response = await InstitutionUserService.viewRefundStatsByRefundStartDate(fromDate, toDate, token)
                  const biddersAmountRequestedToBeRefund = response.data?.biddersAmountRequestedToBeRefund
                  setBiddersAmountRequestedToBeRefund(response.data?.biddersAmountRequestedToBeRefund)
                  const bailiffAmountRequestedToBeRefunded = response.data?.bailiffAmountRequestedToBeRefunded
                  setBailiffAmountRequestedToBeRefunded(response.data?.bailiffAmountRequestedToBeRefunded)
                  const newBiddersAmountRequestedToBeRefunded = response.data?.newBiddersAmountRequestedToBeRefunded
                  setNewBiddersAmountRequestedToBeRefunded(response.data?.newBiddersAmountRequestedToBeRefunded)
                  const newBailiffAmountRequestedToBeRefunded = response.data?.newBailiffAmountRequestedToBeRefunded
                  setNewBailiffAmountRequestedToBeRefunded(response.data?.newBailiffAmountRequestedToBeRefunded)
                  const tp = response.data?.totalPayments
                  setTotalPaidForRange(tp != null && tp !== '' ? String(tp) : '')
              } catch (err) {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-expect-error
                  setError('Failed to fetch refund stats')
                  // eslint-disable-next-line no-console
                  console.error(err)
              } finally {
                  setLoading(false)
              }
          }

          void fetchRefundStats()
      },
      [fromDate, toDate, token])

    useEffect(() => {
        // Fetch data on component mount
        OnRefundRequestSearch();
    }, []);

    useEffect(() => {
        if (activeTab === 'bidders') {
            const total = refundRequestList.reduce((acc, curr) => acc + curr.amount, 0);
            setTotalAmount(total);
        } else if (activeTab === 'bailiffs') {
            const total = bailiffRefundRequestList.reduce((acc, curr) => acc + curr.amount, 0);
            setTotalAmount(total);
        }
    }, [refundRequestList, bailiffRefundRequestList, activeTab]);

    React.useEffect(() => {
        InstitutionUserService.RefundRequestStats()
            .then((res: any) => {
                setStats(res.data); // assuming the stats are in res.data
            })
            .catch((err) => {
                message.error(err?.message);
            });
    }, []);

    useEffect(() => {
        OnRefundRequestSearch()
        // eslint-disable-next-line
    }, [clear, pagination.current, pagination.pageSize, fromDate, toDate])
    const handleTableChange = (pagination: any) => {
        setPagination(pagination)
    }
    let filter = ''
    if (filterStatus) {
        filter = filter + 'Type'
    }
    if (fromDate) {
        filter = filter === '' ? filter + 'From Date' : filter + ', From Date'
    }
    if (toDate) {
        filter = filter === '' ? filter + 'To Date' : filter + ', To Date'
    }

    const updateRefundRequestStatus = async (): Promise<void> => {
        try {
            const refundRequests = refundRequestList.map(item => ({ transaction_reference: item.transaction_reference }));
            const response = await InstitutionUserService.updateRefundRequestStatus({ RefundRequests: refundRequests });

            if (response.status === 200) {
                // Handle success
            } else {
                // Handle unexpected response status
            }
        } catch (error) {
            // Handle error
        }
    };

    const updateBailiffRefundRequestStatus = async (): Promise<void> => {
        try {
            const createdBy = userInfo?.id || 'default_user_id';
            const bailiffRefundRequests = bailiffRefundRequestList.map(item => {
                const phone = String(
                    (item as { bailiff_phone_number?: string }).bailiff_phone_number ??
                    (item as { bailiffPhoneNumber?: string }).bailiffPhoneNumber ??
                    ''
                ).trim()
                return {
                    transaction_reference: item.transaction_reference,
                    created_by: createdBy,
                    ...(phone !== '' ? { bailiff_phone_number: phone } : {})
                }
            })
            const response = await InstitutionUserService.updateBailiffRefundRequestStatus({ BailiffRefundRequests: bailiffRefundRequests });

            if (response.status === 200) {
                // Handle success
            } else {
                // Handle unexpected response status
            }
        } catch (error) {
            // Handle error
        }
    };

    const handleDownloadExcel = async (): Promise<void> => {
        try {
            let dataToDownload: DataType[] = []
            if (activeTab === 'bidders') {
                dataToDownload = refundRequestList
                await updateRefundRequestStatus()
            } else if (activeTab === 'bailiffs') {
                dataToDownload = bailiffRefundRequestList
                await updateBailiffRefundRequestStatus()
            }

            if (dataToDownload.length === 0) {
                message.warning('No data to download.')
                return
            }

            const columns = [
                'bank_code',
                'transaction_reference',
                'debit_account_number',
                'debit_account_name',
                'beneficiary_bank_name',
                'beneficiary_account_name',
                'beneficiary_account_number',
                'amount',
                'transaction_currency',
                'reason'
            ]

            const header = columns.map(c => c.toUpperCase().replace(/_/g, ' ')).join(',') + '\n'

            const csvRows = dataToDownload.map(row => {
                return columns.map(colName => {
                    if (colName === 'transaction_reference') {
                        return ''
                    }
                    let cell = row[colName as keyof DataType] ?? ''
                    cell = String(cell)
                    if (cell.includes(',') || cell.includes('"') || cell.includes('\n')) {
                        cell = `"${cell.replace(/"/g, '""')}"`
                    }
                    return cell
                }).join(',')
            }).join('\n')

            const csvContent = header + csvRows

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })

            if ((navigator as any).msSaveBlob) { // For IE 10+
                (navigator as any).msSaveBlob(blob, 'BankTransfersTemplate.csv')
            } else {
                const link = document.createElement('a')
                if (link.download !== undefined) {
                    const url = URL.createObjectURL(blob)
                    link.setAttribute('href', url)
                    link.setAttribute('download', 'BankTransfersTemplate.csv')
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                } else {
                    console.error('File download not supported on this browser.')
                }
            }
        } catch (error) {
            console.error('Error occurred while downloading CSV:', error)
            message.warning('Error occurred while downloading CSV and updating refund request status.')
        }
    }
    const convertToExcel = (data: { [x: string]: any }[], maxColumns: number = 10): XLSX.WorkBook => {
        console.log('Converting data to Excel format...');

        const columnsToSkip = ['refund_request_id', 'bailiff_refund_request_id'];
        const originalColumns = Object.keys(data[0])
            .filter(col => !columnsToSkip.includes(col))
            .slice(0, maxColumns);

        console.log('Original Columns:', originalColumns);

        const sheetData = data.map(row => {
            const rowData: { [key: string]: any } = {};
            originalColumns.forEach(column => {
                const columnKey = column.toLowerCase().replace(/ /g, '_');
                rowData[column] = row[columnKey] || '';
            });
            return rowData;
        });

        console.log('Sheet Data:', sheetData);
        // Create a worksheet from the data
        const ws = XLSX.utils.json_to_sheet(sheetData, { header: originalColumns });
        // Create a workbook and add the worksheet to it
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        console.log('Excel workbook created.');

        return wb;
    };

    const downloadExcel = (wb: XLSX.WorkBook, fileName: string) => {
        console.log('Preparing to download Excel file...');

        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        if ((navigator as any).msSaveBlob) { // For IE 10+
            (navigator as any).msSaveBlob(blob, fileName);
        } else {
            const link = document.createElement('a');
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                console.error('File download not supported on this browser.');
            }
        }

        console.log('Excel file downloaded.');
    };

    const handleDownloadExcelFile = async (): Promise<void> => {
        try {
            console.log('Handling download of Excel file...');

            let dataToDownload: { [x: string]: any }[] = [];
            if (activeTab === 'bidders') {
                dataToDownload = refundRequestList;
            } else if (activeTab === 'bailiffs') {
                dataToDownload = bailiffRefundRequestList;
            }

            console.log('Data to download:', dataToDownload);

            const wb = convertToExcel(dataToDownload, 10);
            downloadExcel(wb, 'New Refund Request Report.xlsx');
        } catch (error) {
            console.error('Error occurred while downloading Excel:', error);
            message.warning("Error occurred while downloading Excel and updating refund request status.");
        }
    };

    const clearFilter = (): void => {
        setfilterStatus('')
        form.setFieldValue('filterStatus', '')
        form.setFieldValue('range_picker', ['', ''])
        setFromDate('')
        setToDate('')
        setClear(true)
    }

    const handleTabChange = (key: string) => {
        setActiveTab(key);
    };

    useEffect(() => {
        OnRefundRequestSearch();
    }, [activeTab, pagination.pageSize, pagination.current, filterStatus, fromDate, toDate]);

    const OnRefundRequestSearch = (event?: any): void => {
        setLoading(true);
        const service = activeTab === 'bidders' ? InstitutionUserService.GetRefundRequestList : InstitutionUserService.GetNewBailiffRefundRequestList;
        service(
            pagination.pageSize as number,
            pagination.current as number,
            event?.target?.value,
            fromDate,
            toDate
        )
            .then((res: any) => {
                if (res.status === 200) {
                    if (activeTab === 'bidders') {
                        setRefundRequestList(res?.data);
                        setPaymentsMeta(res?.meta)
                    } else if (activeTab === 'bailiffs') {
                        setBailiffRefundRequestList(res?.data);
                        setPaymentsMeta(res?.meta)
                    }
                    setPagination((prev) => ({
                        ...prev,
                        total: res?.meta?.total
                    }));
                    setLoading(false);
                }
            })
            .catch((err: any) => {
                if (err?.message !== 'Operation canceled due to new request.') {
                    message.error(err?.message);
                }
                setLoading(false);
            });
    };

    const biddersColumns: ColumnsType<DataType> = [
        {
            title: 'No.',
            dataIndex: 'index',
            key: 'index',
            width: 50,
            render: (text, record, index) => {
                const pageNumber = pagination.current || 1
                const pageSize = pagination.pageSize || 10
                const globalIndex = (pageNumber - 1) * pageSize + (index + 1)
                return <span>{globalIndex}</span>;
            },
            sorter: (a, b) => a.index - b.index,
            sortOrder: sortedInfo.columnKey === 'index' ? sortedInfo.order : null,
            ellipsis: false,
        },
        {
            title: 'Transaction Reference',
            dataIndex: 'transaction_reference',
            key: 'transaction_reference',
            width: 100,
            sorter: (a: any, b: any) => a?.transaction_reference.localeCompare(b?.transaction_reference),
            sortOrder: sortedInfo?.columnKey === 'transaction_reference' ? sortedInfo?.order : null,
            ellipsis: true,
            render: (text: string, record: any) => (
                <Tooltip
                    title={`
                Bank Code: ${record.bank_code}
                Debit Bank Name: ${record.debit_account_name}
                Debit Bank Number: ${record.debit_account_number}
                Reason: ${record.reason}
            `}>
                    <span>{text}</span>
                </Tooltip>
            ),
        },
        {
            title: 'Beneficiary Account Name',
            dataIndex: 'beneficiary_account_name',
            key: 'beneficiary_account_name',
            width: 120,
            sorter: (a: any, b: any) =>
                a?.beneficiary_account_name.localeCompare(b?.beneficiary_account_name),
            sortOrder: sortedInfo?.columnKey === 'beneficiary_account_name' ? sortedInfo?.order : null,
            ellipsis: true,
            render: (text: string, record: any) => (
                <Tooltip
                    title={`
                Bank Code: ${record.bank_code}
                Debit Bank Name: ${record.debit_account_name}
                Debit Bank Number: ${record.debit_account_number}
                Reason: ${record.reason}
            `}>
                    <span>{text}</span>
                </Tooltip>
            ),
        },
        {
            title: 'Beneficiary Bank Name',
            dataIndex: 'beneficiary_bank_name',
            key: 'beneficiary_bank_name',
            width: 150,
            sorter: (a: any, b: any) => a?.beneficiary_bank_name.localeCompare(b?.beneficiary_bank_name),
            sortOrder: sortedInfo?.columnKey === 'beneficiary_bank_name' ? sortedInfo?.order : null,
            ellipsis: true,
            render: (text: string, record: any) => (
                <Tooltip
                    title={`
                Bank Code: ${record.bank_code}
                Debit Bank Name: ${record.debit_account_name}
                Debit Bank Number: ${record.debit_account_number}
                Reason: ${record.reason}
            `}>
                    <span>{text}</span>
                </Tooltip>
            ),
        },
        {
            title: 'Beneficiary Account Number',
            dataIndex: 'beneficiary_account_number',
            key: 'beneficiary_account_number',
            width: 150,
            sorter: (a: any, b: any) => a?.beneficiary_account_number.localeCompare(b?.beneficiary_account_number),
            sortOrder: sortedInfo?.columnKey === 'beneficiary_account_number' ? sortedInfo?.order : null,
            ellipsis: true,
            render: (text: string, record: any) => (
                <Tooltip
                    title={`
                Bank Code: ${record.bank_code}
                Debit Bank Name: ${record.debit_account_name}
                Debit Bank Number: ${record.debit_account_number}
                Reason: ${record.reason}
            `}>
                    <span>{text}</span>
                </Tooltip>
            ),
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            width: 130,
            render: (_text: any, record: any) => {
                const amount = parseInt(record?.amount, 10)
                return `${amount.toLocaleString()} Rwf`;
            },
            sorter: (a: any, b: any) => Number(a?.amount) - Number(b?.amount),
            sortOrder: sortedInfo?.columnKey === 'amount' ? sortedInfo?.order : null,
            ellipsis: true
        },
        {
            title: 'Status',
            dataIndex: 'status',
            render: (text: any, record: any) => {
                const tagColorClass = record?.status === 'RECEIVED REQUEST' ? 'custom-tag-success' : 'custom-tag-error';

                return (
                    <Tag className={`custom-tag ${tagColorClass}`}>
                        {record?.status}
                    </Tag>
                );
            },
            key: 'status',
            width: 150,
            sorter: (a: any, b: any) => a.status.localeCompare(b.status),
            sortOrder: sortedInfo?.columnKey === 'status' ? sortedInfo?.order : null,
            ellipsis: true,
        },
        {
            title: 'Action',
            dataIndex: 'action',
            width: 100,
            fixed: 'right',
            render: (text: any, record: any) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                    <i
                        className="far fa-eye cursor-pointer icon-style"
                        onClick={() => {
                            navigate('/view-refund-request', { state: record })
                        }}
                    ></i>
                </div>
            )
        }
    ]
    const bailiffsColumns: ColumnsType<DataType> = [
        {
            title: 'No.',
            dataIndex: 'index',
            key: 'index',
            width: 50,
            render: (text, record, index) => {
                const pageNumber = pagination.current || 1
                const pageSize = pagination.pageSize || 10
                const globalIndex = (pageNumber - 1) * pageSize + (index + 1)
                return <span>{globalIndex}</span>;
            },
            sorter: (a, b) => a.index - b.index,
            sortOrder: sortedInfo.columnKey === 'index' ? sortedInfo.order : null,
            ellipsis: false,
        },
        {
            title: 'Transaction Reference',
            dataIndex: 'transaction_reference',
            key: 'transaction_reference',
            width: 100,
            sorter: (a: any, b: any) => a?.transaction_reference.localeCompare(b?.transaction_reference),
            sortOrder: sortedInfo?.columnKey === 'transaction_reference' ? sortedInfo?.order : null,
            ellipsis: true,
            render: (text: string, record: any) => (
                <Tooltip
                    title={`
                Bank Code: ${record.bank_code}
                Debit Bank Name: ${record.debit_account_name}
                Debit Bank Number: ${record.debit_account_number}
                Reason: ${record.reason}
            `}>
                    <span>{text}</span>
                </Tooltip>
            ),
        },
        {
            title: 'Beneficiary Account Name',
            dataIndex: 'beneficiary_account_name',
            key: 'beneficiary_account_name',
            width: 120,
            sorter: (a: any, b: any) =>
                a?.beneficiary_account_name.localeCompare(b?.beneficiary_account_name),
            sortOrder: sortedInfo?.columnKey === 'beneficiary_account_name' ? sortedInfo?.order : null,
            ellipsis: true,
            render: (text: string, record: any) => (
                <Tooltip
                    title={`
                Bank Code: ${record.bank_code}
                Debit Bank Name: ${record.debit_account_name}
                Debit Bank Number: ${record.debit_account_number}
                Reason: ${record.reason}
            `}>
                    <span>{text}</span>
                </Tooltip>
            ),
        },
        {
            title: 'Beneficiary Bank Name',
            dataIndex: 'beneficiary_bank_name',
            key: 'beneficiary_bank_name',
            width: 150,
            sorter: (a: any, b: any) => a?.beneficiary_bank_name.localeCompare(b?.beneficiary_bank_name),
            sortOrder: sortedInfo?.columnKey === 'beneficiary_bank_name' ? sortedInfo?.order : null,
            ellipsis: true,
            render: (text: string, record: any) => (
                <Tooltip
                    title={`
                Bank Code: ${record.bank_code}
                Debit Bank Name: ${record.debit_account_name}
                Debit Bank Number: ${record.debit_account_number}
                Reason: ${record.reason}
            `}>
                    <span>{text}</span>
                </Tooltip>
            ),
        },
        {
            title: 'Beneficiary Account Number',
            dataIndex: 'beneficiary_account_number',
            key: 'beneficiary_account_number',
            width: 150,
            sorter: (a: any, b: any) => a?.beneficiary_account_number.localeCompare(b?.beneficiary_account_number),
            sortOrder: sortedInfo?.columnKey === 'beneficiary_account_number' ? sortedInfo?.order : null,
            ellipsis: true,
            render: (text: string, record: any) => (
                <Tooltip
                    title={`
                Bank Code: ${record.bank_code}
                Debit Bank Name: ${record.debit_account_name}
                Debit Bank Number: ${record.debit_account_number}
                Reason: ${record.reason}
            `}>
                    <span>{text}</span>
                </Tooltip>
            ),
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            width: 130,
            render: (_text: any, record: any) => {
                const amount = parseInt(record?.amount, 10)
                return amount.toLocaleString()
            },
            sorter: (a: any, b: any) => Number(a?.amount) - Number(b?.amount),
            sortOrder: sortedInfo?.columnKey === 'amount' ? sortedInfo?.order : null,
            ellipsis: true
        },
        {
            title: 'Status',
            dataIndex: 'status',
            render: (text: any, record: any) => {
                const tagColorClass = record?.status === 'RECEIVED REQUEST' ? 'custom-tag-success' : 'custom-tag-error';

                return (
                    <Tag className={`custom-tag ${tagColorClass}`}>
                        {record?.status}
                    </Tag>
                );
            },
            key: 'status',
            width: 150,
            sorter: (a: any, b: any) => a.status.localeCompare(b.status),
            sortOrder: sortedInfo?.columnKey === 'status' ? sortedInfo?.order : null,
            ellipsis: true
        },
        {
            title: 'Action',
            dataIndex: 'action',
            width: 100,
            fixed: 'right',
            render: (text: any, record: any) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                    <i
                        className="far fa-eye cursor-pointer icon-style"
                        onClick={() => {
                            navigate('/view-bailiff-refund-request', { state: record })
                        }}
                    ></i>
                </div>
            )
        }
    ]
    return (
      <div style={{ width: '95%', margin: '0 auto' }}>
          {/* Add custom styles for table rows */}
          <style>{`
            .table-row-light {
              background-color: #ffffff;
            }
            .table-row-dark {
              background-color: #ffffff;
            }
            .table-row-light:hover,
            .table-row-dark:hover {
              background-color: #f9fafb !important;
            }
            .ant-table-thead > tr > th {
              background-color: #f8f8f8 !important;
              border-bottom: 1px solid #e5e7eb !important;
              border-right: 1px solid #e5e7eb !important;
              font-weight: 600 !important;
              color: #374151 !important;
              font-size: 14px !important;
              text-align: left !important;
              padding: 12px 16px !important;
              font-family: 'Avenir', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif !important;
            }
            .ant-table-thead > tr > th:last-child {
              border-right: none !important;
            }
            .ant-table-tbody > tr > td {
              border-bottom: 1px solid #e5e7eb !important;
              border-right: 1px solid #e5e7eb !important;
              padding: 12px 16px !important;
              text-align: left !important;
              font-size: 14px !important;
              color: #1f2937 !important;
            }
            .ant-table-tbody > tr > td:last-child {
              border-right: none !important;
            }
            .ant-table-column-sorter {
              color: #9ca3af !important;
              margin-left: 4px !important;
            }
            .ant-table-column-sorter-up,
            .ant-table-column-sorter-down {
              color: #9ca3af !important;
              font-size: 12px !important;
            }
            .ant-table-column-sorter-up.active,
            .ant-table-column-sorter-down.active {
              color: #374151 !important;
            }
          `}</style>

          <div className="px-5 py-4 border-b-slate-200 border border-solid" style={{
            background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
            borderRadius: '0 0 12px 12px',
            marginBottom: '20px',
          }}>
              <div className="flex justify-between items-center">
                  <div className="text-title font-bold flex items-center">
                      <div style={{
                        background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
                        borderRadius: '50%',
                        width: '48px',
                        height: '48px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: '16px',
                        boxShadow: '0 4px 12px rgba(55, 118, 47, 0.3)',
                      }}>
                        <i className="fas fa-file-invoice-dollar" style={{ fontSize: '22px', color: '#ffffff' }}></i>
                      </div>
                      <div>
                        <h2 className="text-title font-bold" style={{
                          margin: 0,
                          background: 'linear-gradient(135deg, #37762f 0%, #4a7c59 100%)',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          backgroundClip: 'text',
                        }}>
                          Refund Request Management
                        </h2>
                        <p style={{
                          margin: '4px 0 0 0',
                          fontSize: '14px',
                          color: '#6b7280',
                          fontWeight: '500',
                        }}>
                          Financial Refund Management • Process & Track Requests
                        </p>
                      </div>
                  </div>
                  <div className="md:w-1/5"></div>
              </div>
          </div>
          <div className={styles['header-stat']}>

              <div style={{ margin: '0 8px' }}>
                <RefundStatsRangeAlert fromDate={fromDate} toDate={toDate} />
              </div>
              {/* Enhanced stats section with hover effects - Responsive */}
              <div style={{
                padding: '20px',
                backgroundColor: '#fafafa',
                borderRadius: '8px',
                margin: '0 8px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              }}
              className={styles['stats-container']}
              >
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={5}>
                    <div
                      className="stat-card"
                      style={{
                        width: '100%',
                        background: '#f8fafc',
                        padding: '20px',
                        borderRadius: '12px',
                        border: '1px solid #e5e7eb',
                        textAlign: 'center',
                        color: '#111827',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                        cursor: 'default',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
                      }}
                    >
                      <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                        Total Amount Requested
                      </div>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
                        {((parseMoneyAmount(BailiffAmountRequestedToBeRefunded) ?? 0) + (parseMoneyAmount(BiddersAmountRequestedToBeRefund) ?? 0)).toLocaleString()} Rwf
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8} lg={6} xl={5} xxl={5}>
                    <div
                      className="stat-card"
                      style={{
                        width: '100%',
                        background: '#f8fafc',
                        padding: '20px',
                        borderRadius: '12px',
                        border: '1px solid #e5e7eb',
                        textAlign: 'center',
                        color: '#111827',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                        cursor: 'default',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
                      }}
                    >
                      <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                        New Amount Requested
                      </div>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
                        {((parseMoneyAmount(NewBiddersAmountRequestedToBeRefunded) ?? 0) + (parseMoneyAmount(NewBailiffAmountRequestedToBeRefunded) ?? 0)).toLocaleString()} Rwf
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8} lg={4} xl={5} xxl={5}>
                    <div
                      className="stat-card"
                      style={{
                        width: '100%',
                        background: '#f8fafc',
                        padding: '20px',
                        borderRadius: '12px',
                        border: '1px solid #e5e7eb',
                        textAlign: 'center',
                        color: '#111827',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                        cursor: 'default',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
                      }}
                    >
                      <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                        Remaining to Request
                      </div>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
                        {Math.max(
                          0,
                          parseMoneyAmount(totalPaidForRange) -
                            (parseMoneyAmount(BiddersAmountRequestedToBeRefund) + parseMoneyAmount(BailiffAmountRequestedToBeRefunded))
                        ).toLocaleString()} Rwf
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8} lg={4} xl={5} xxl={5}>
                    <div
                      className="stat-card"
                      style={{
                        width: '100%',
                        background: '#f8fafc',
                        padding: '20px',
                        borderRadius: '12px',
                        border: '1px solid #e5e7eb',
                        textAlign: 'center',
                        color: '#111827',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                        cursor: 'default',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
                      }}
                    >
                      <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                        Total Paid Amount
                      </div>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
                        {(parseMoneyAmount(totalPaidForRange)).toLocaleString()} Rwf
                      </div>
                    </div>
                  </Col>

                  <Col xs={24} sm={12} md={8} lg={4} xl={4} xxl={4}>
                    <div
                      className="stat-card"
                      style={{
                        width: '100%',
                        background: '#f8fafc',
                        padding: '20px',
                        borderRadius: '12px',
                        border: '1px solid #e5e7eb',
                        textAlign: 'center',
                        color: '#111827',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                        cursor: 'default',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.12)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
                      }}
                    >
                      <div style={{ fontSize: '14px', color: '#6b7280', marginBottom: '8px', fontWeight: 'bold' }}>
                        Total Refunded Amount
                      </div>
                      <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#37762f' }}>
                        {(((parseMoneyAmount(BiddersAmountRequestedToBeRefund) + parseMoneyAmount(BailiffAmountRequestedToBeRefunded))) - ((parseMoneyAmount(NewBiddersAmountRequestedToBeRefunded)) + (parseMoneyAmount(NewBailiffAmountRequestedToBeRefunded)))).toLocaleString()} Rwf
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>

          </div>

          <div className="px-2">
              <div className="py-1">
                  <Form
                    name="normal_login"
                    layout="vertical"
                    className="login-form p-2"
                    initialValues={{ remember: true }}
                    form={form}
                  >
                      <Card
                        className="bg-gradient-to-r from-blue-50 to-indigo-50"
                        style={{
                          borderRadius: '12px',
                          border: '1px solid #e0e7ff',
                          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
                        }}
                      >
                          <Row gutter={16}>
                              <Col xs={24} xl={18}>
                                  <Form.Item
                                    name="range_picker"
                                    label={<span style={{ fontWeight: '600', color: '#374151' }}>Select Date Range</span>}
                                  >
                                      <RangePicker
                                        size="large"
                                        className="w-full"
                                        allowClear
                                        style={{
                                          borderRadius: '8px',
                                          border: '2px solid #e5e7eb',
                                          transition: 'border-color 0.2s ease',
                                        }}
                                        onChange={(dates, dateStrings) => {
                                            if (dates) {
                                                setFromDate(dates[0] ? dates[0].startOf('day').toISOString() : '');
                                                setToDate(dates[1] ? dates[1].endOf('day').toISOString() : '');
                                            } else {
                                                setFromDate('');
                                                setToDate('');
                                            }
                                        }}
                                      />
                                  </Form.Item>
                                  {filter !== ''
                                    ? (
                                      <div className="flex justify-between pb-2.5 md:pb-0">
                                          <div>
                                              Applied filters: <span className="font-medium">{filter}</span>
                                          </div>
                                          <div
                                            className="bg-black text-center py-0.5 px-2.5 text-white rounded-sm font-medium cursor-pointer"
                                            onClick={clearFilter}
                                          >
                                              Clear X
                                          </div>
                                      </div>
                                    )
                                    : (
                                      ''
                                    )}
                              </Col>
                              <Col xs={24} xl={6}>
                                  <Form.Item label={<span style={{ color: 'transparent' }}>Action</span>}>
                                      <Button
                                        type="primary"
                                        size="large"
                                        className="w-full font-bold"
                                        onClick={handleDownloadExcel}
                                        disabled={fromDate.length === 0 || toDate.length === 0}
                                        style={{
                                          background: fromDate.length === 0 || toDate.length === 0
                                            ? '#d1d5db'
                                            : 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                          border: 'none',
                                          borderRadius: '8px',
                                          height: '48px',
                                          fontSize: '16px',
                                          fontWeight: '600',
                                          boxShadow: fromDate.length === 0 || toDate.length === 0
                                            ? 'none'
                                            : '0 4px 12px rgba(16, 185, 129, 0.3)',
                                          transition: 'all 0.2s ease',
                                        }}
                                        onMouseEnter={(e) => {
                                          if (fromDate.length > 0 && toDate.length > 0) {
                                            e.currentTarget.style.transform = 'translateY(-1px)';
                                            e.currentTarget.style.boxShadow = '0 6px 16px rgba(16, 185, 129, 0.4)';
                                          }
                                        }}
                                        onMouseLeave={(e) => {
                                          if (fromDate.length > 0 && toDate.length > 0) {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.3)';
                                          }
                                        }}
                                      >
                                          Filter & Download
                                      </Button>
                                  </Form.Item>
                              </Col>
                          </Row>
                      </Card>
                  </Form>
              </div>
              <Card
                style={{
                  marginTop: '8px',
                  borderRadius: '16px',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
                  border: '1px solid #e5e7eb',
                  overflow: 'hidden'
                }}
              >
                <div style={{
                  background: '#dff0de',
                  color: '#000000',
                  fontWeight: 'normal',
                  padding: '16px 20px',
                  margin: '-24px -24px 24px -24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <i className="fas fa-users" style={{ fontSize: '24px' }}></i>
                    <span style={{ fontSize: '18px', fontWeight: 'normal' }}>
                      {activeTab === 'bidders'
                        ? `All Bidders (${refundRequestList.length})`
                        : `All Bailiffs (${bailiffRefundRequestList.length})`
                      }
                    </span>
                  </div>
                </div>

                <Tabs
                    onChange={(key) => handleTabChange(key)}
                    type="card"
                    size="large"
                    defaultActiveKey="bidders"
                    activeKey={activeTab}
                    tabBarExtraContent={
                      <div className="w-full flex flex-col md:flex-row md:items-center md:space-x-4 space-y-2 md:space-y-0">
                        <Button
                          onClick={handleDownloadExcelFile}
                          style={{
                            background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                            border: 'none',
                            borderRadius: '8px',
                            color: 'white',
                            fontWeight: '600',
                            height: '40px',
                            padding: '0 16px',
                            boxShadow: '0 2px 4px rgba(59, 130, 246, 0.3)',
                            transition: 'all 0.2s ease',
                          }}
                        >
                          Download Report
                        </Button>
                        <Button type="link" className="md:ml-2 w-full md:w-auto" onClick={clearFilter}>
                          Clear Filter
                        </Button>
                      </div>
                    }
                  >
                      <Tabs.TabPane
                        tab={
                          <span style={{
                            fontWeight: '600',
                            color: '#374151',
                            display: 'flex',
                            alignItems: 'center',
                          }}>
                            Bidders
                          </span>
                        }
                        key="bidders"
                      >
                          <div style={{ marginBottom: '20px' }}>
                            <Input
                              size="large"
                              placeholder="Search by transaction reference, beneficiary name, or account number..."
                              prefix={<ZoomOutOutlined style={{ color: '#667eea', fontSize: '18px' }} />}
                              onChange={OnRefundRequestSearch}
                              style={{
                                borderRadius: '10px',
                                border: '2px solid #e5e7eb',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                              }}
                            />
                          </div>
                          <Spin
                            spinning={loading}
                            indicator={antIcon}
                            tip={
                              <span style={{
                                color: '#37762f',
                                fontWeight: '500',
                              }}>
                                Loading bidders data...
                              </span>
                            }
                          >
                            <div style={{ width: '100%', overflowX: 'auto' }}>
                                <Table
                                  columns={biddersColumns}
                                  dataSource={refundRequestList}
                                  onChange={handleTableChange}
                                  pagination={{
                                    ...pagination,
                                    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                                    showSizeChanger: true,
                                    showQuickJumper: true,
                                    hideOnSinglePage: false,
                                    pageSizeOptions: ['10', '20', '50', '100'],
                                    showLessItems: true,
                                    style: {
                                      background: '#F5F5F5',
                                      borderRadius: '8px',
                                      padding: '12px',
                                      border: '1px solid #e5e7eb',
                                      marginTop: '16px'
                                    }
                                  }}
                                  loading={loading}
                                  scroll={{ x: 900 }}
                                  style={{
                                    minWidth: 900,
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                  }}
                                  rowClassName={(record, index) =>
                                    index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
                                  }
                                />
                            </div>
                          </Spin>
                      </Tabs.TabPane>
                      <Tabs.TabPane
                        tab={
                          <span style={{
                            fontWeight: '600',
                            color: '#374151',
                            display: 'flex',
                            alignItems: 'center',
                          }}>
                            Bailiffs
                          </span>
                        }
                        key="bailiffs"
                      >
                          <div style={{ marginBottom: '20px' }}>
                            <Input
                              size="large"
                              placeholder="Search by transaction reference, beneficiary name, or account number..."
                              prefix={<ZoomOutOutlined style={{ color: '#667eea', fontSize: '18px' }} />}
                              onChange={OnRefundRequestSearch}
                              style={{
                                borderRadius: '10px',
                                border: '2px solid #e5e7eb',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                              }}
                            />
                          </div>
                          <Spin
                            spinning={loading}
                            indicator={antIcon}
                            tip={
                              <span style={{
                                color: '#37762f',
                                fontWeight: '500',
                              }}>
                                Loading bailiffs data...
                              </span>
                            }
                          >
                            <div style={{ width: '100%', overflowX: 'auto' }}>
                                <Table
                                  columns={bailiffsColumns}
                                  dataSource={bailiffRefundRequestList}
                                  onChange={handleTableChange}
                                  pagination={{
                                    ...pagination,
                                    showSizeChanger: true,
                                    showQuickJumper: true,
                                    showTotal: (total, range) =>
                                      `${range[0]}-${range[1]} of ${total} bailiffs`,
                                    style: {
                                      marginTop: '16px',
                                      textAlign: 'right',
                                    },
                                  }}
                                  loading={loading}
                                  scroll={{ x: 900 }}
                                  style={{
                                    minWidth: 900,
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                  }}
                                  rowClassName={(record, index) =>
                                    index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
                                  }
                                />
                            </div>
                          </Spin>
                      </Tabs.TabPane>
                  </Tabs>
              </Card>
          </div>
      </div>
    );
};

export default BiddersRefundRequest;
